import { render, staticRenderFns } from "./EditBundleProductModal.vue?vue&type=template&id=181a5896&"
import script from "./EditBundleProductModal.vue?vue&type=script&lang=js&"
export * from "./EditBundleProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports